import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import USER_MANAGEMENT_CONTROLLER, { ADD_USER_BLOCK_STATE, getAddUserBlockState } from '../../controllers/userManagement';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import UsersTable from './UsersTable';
import NoData from '../page/NoData';
import { Route } from 'react-router-dom';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';

const PAGE_NAME = "USER_MANAGEMENT";
const log = new Logger(PAGE_NAME, LOG_LEVELS.DEBUG);

export const UserManagementPage = (props) => {

    const [toggleFilterPanel, setToggleFilterPanel] = useState(true);

    const allCompanyOptions = props.allCompanies?.map((company) => {
        return {
            label: `${company.code} - ${company.name}`,
            value: company.id.toString()
        };
    });

    useEffect(() => {
        props.onPageLoad();
    }, []);

    const handleToggleFilterPanel = () => {
        setToggleFilterPanel(!toggleFilterPanel);
    }

    const addUserAllowed = props.addUserBlockState === ADD_USER_BLOCK_STATE.ALLOWED;

    const onDeleteUserHandler = (userId) => {
        log.clearAllDictionaryErrors();
        if (props.loggedInUserId === userId) {
            log.setDictionaryMessage(ALL_MESSAGES.USER_DELETE_VALIDATION);
            return;
        }
        props.onDeleteUser(userId, (response) => {
            props.onLoadUsers();
            log.setDictionaryMessage(ALL_MESSAGES.USER_DELETE_SUCCESS);
        }, (error) => {
            log.setDictionaryMessage(ALL_MESSAGES.USER_DELETE_ERROR);
        });
    };
    return (
        <div className="content-area" data-testid="user-management-page">
            <s-container>
                <ApplicationMessages messageType="applicationError" messageIds={[ALL_MESSAGES.USER_DELETE_ERROR, ALL_MESSAGES.USER_DELETE_VALIDATION]} />
                <ApplicationMessages messageType="applicationSuccess" messageIds={[ALL_MESSAGES.USER_DELETE_SUCCESS]} />
                <h1><LanguageStringResolver string='TitleUserManagement' /></h1>
                <p><LanguageStringResolver string='UserManagementPageDescription' /></p>
                {props.addUserBlockState === ADD_USER_BLOCK_STATE.BLOCKED &&
                    <s-alert status="warning" class="mt10" nodismiss={true} data-testid="add-user-blocked-banner">
                        <div><LanguageStringResolver string='UserManagement_AddUserBlocked' /></div>
                    </s-alert>
                }
                <s-row>
                    <s-col span="6">
                        <button
                            className={toggleFilterPanel ? "toggle-button icon-leading mt10" : "secondary icon-leading mt10"}
                            data-testid="filter-button"
                            onClick={handleToggleFilterPanel}
                        >
                            <s-icon name="filter" />
                            <LanguageStringResolver string='FilterButton' />
                        </button>
                    </s-col>
                    <s-col span="6">
                        <div className="text-align-right mb30">
                            <Route render={({ history }) => (
                                <button
                                    className="primary mt10 mb10 ml30"
                                    data-testid="add-user-button"
                                    disabled={!addUserAllowed}
                                    aria-disabled={addUserAllowed ? undefined : 'true'}
                                    onClick={() => addUserAllowed && history.push('/AddUser')}
                                >
                                    <s-icon class="mr10" name="plus" aria-label="plus"></s-icon>
                                    <LanguageStringResolver string='AddUserButton' />
                                </button>
                            )} />
                        </div>
                    </s-col>
                </s-row>
                {
                    (props.users && props.users.length) > 0 ?
                        <UsersTable
                            users={props.users}
                            companiesLookup={props.companiesLookup}
                            languages={props.languages}
                            toggleFilterPanel={toggleFilterPanel}
                            setToggleFilterPanel={setToggleFilterPanel}
                            allCompanyOptions={allCompanyOptions}
                            deleteUserHandler={onDeleteUserHandler}
                        />
                        :
                        <NoData noDataText="users_NoData" />
                }
            </s-container>
        </div>
    );
};

/* We don't test state mapping functions in connected components */
/* istanbul ignore next */
export function mapStateToProps(state) {
    return {
        users: state.userManagement?.data,
        companiesLookup: state.userManagement?.companiesLookup,
        error: (state.userManagement?.error),
        languages: state.languages,
        allCompanies: state.userManagement?.allCompanies,
        loggedInUserId: state.authentication?.data?.userName,
        addUserBlockState: getAddUserBlockState(state)
    };
}

/* We don't test dispatcher mapping functions in connected components */
/* istanbul ignore next */
export function mapDispatchersToProps(dispatch) {
    return {
        onLoadUsers: () => {
            dispatch(USER_MANAGEMENT_CONTROLLER.doLoad());
        },
        onPageLoad: () => {
            dispatch(USER_MANAGEMENT_CONTROLLER.doLoad());
            dispatch(USER_MANAGEMENT_CONTROLLER.doLoadCompanies());
            dispatch(USER_MANAGEMENT_CONTROLLER.doLoadIamTenantInfo());
        },
        onDeleteUser: (userId, successHandler, errorHandler) => {
            dispatch(USER_MANAGEMENT_CONTROLLER.doDeleteUser(userId, successHandler, errorHandler));
        }
    };
}

export default authorize({
    name: 'UserManagement',
    resource: connect(mapStateToProps, mapDispatchersToProps)(UserManagementPage)
}, AuthorizedResource, {
    showNotAuthorized: true
});
